import { render, staticRenderFns } from "./k5-imgs-swiper.vue?vue&type=template&id=2f87d278&scoped=true&"
import script from "./k5-imgs-swiper.vue?vue&type=script&lang=js&"
export * from "./k5-imgs-swiper.vue?vue&type=script&lang=js&"
import style0 from "./k5-imgs-swiper.vue?vue&type=style&index=0&id=2f87d278&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f87d278",
  null
  
)

export default component.exports